// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/roll-upset.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/roll-upset/roll-upset.js';

mount([g0]);
